module.exports = __webpack_public_path__ + "static/img/before_thirty_two.91d7c3dd.png";